import React from "react";

type Props = {
    className?: string | undefined
    children: React.ReactNode;
}

export const H1: React.FC<Props> = ({children, className}) => {
    return (<h1 className={"text-4xl font-bold tracking-wide " + (className ? className : "")}>{children}</h1>)
}